import Consumers from "../constants/Consumers";
import Config from "../config/config";

export default class LoginDataFactory {

  static create(section: string, userInput: any, labels: any, numberOfOrderItems: number) {
    const user = userInput ?? {
      isLoggedIn: false,
      firstName: '',
      lastName: '',
      userName: '',
      numberOfOrderItems
    };

    const login: any = {
      item: {
        item: {}
      }
    };

    const ecoSystemItem =   {
      id: 6,
      title: 'yettel-ecosystem',
      url: '',
      redirectTo: '',
      cssClass: '',
      img: {
        title: 'circled-menu'
      },
      items: [
        {
          id: 7,
          title: 'Webshop',
          url: Config.webshopUrl,
          redirectTo: Config.webshopUrl,
          img: {
            title: "webshop"
          },
          items: []
        },
        {
          id: 8,
          title: 'Y. Shopping',
          url: Config.ysdUrl,
          redirectTo: Config.ysdUrl,
          img: {
            title: "ysd"
          },
          items: []
        },
        {
          id: 9,
          title: 'Yettel portal',
          url: Config.yettelAppUrl,
          redirectTo: Config.yettelAppUrl,
          img: {
            title: "portal"
          },
          items: []
        },
        {
          id: 10,
          title: 'Y. Pay',
          url: Config.yPayUrl,
          redirectTo: Config.yPayUrl,
          img: {
            title: "ypay"
          },
          items: []
        },
        {
          id: 11,
          title: 'Hipernet TV',
          url: Config.hipernetUrl,
          redirectTo: Config.hipernetUrl,
          img: {
            title: "hipernet"
          },
          items: []
        },
      ]
    };

    if (section === Consumers.PRIVATE_CONSUMER) {
      if (user.isLoggedIn) {
        login.item.item = {
          genericLinks: [
            this.getCartItem(numberOfOrderItems),
            this.getWishListItem(),
            ecoSystemItem,
            {
              id: 1,
              title: (typeof user.userName !== 'undefined' && user.userName !== '') ? user.userName : labels.welcome,
              identifier: 'loggedIn',
              cssClass: '',
              img: {
                title: 'no-profile-photo'
              },
              items: [
                {
                  id: 3,
                  img: {},
                  items: [],
                  url: Config.tnAccountDomain,
                  redirectTo: Config.tnAccountDomain,
                  title: labels.tnAccountSettings
                },
                {
                  id: 4,
                  img: {},
                  items: [],
                  url: "",
                  redirectTo: "",
                  title: labels.logout
                }
              ]
            }
          ]
        };

        return login;
      }

      login.item.item = {
        genericLinks: [
          this.getCartItem(numberOfOrderItems),
          this.getWishListItem(),
          ecoSystemItem,
          {
            id: 1,
            title: labels.signUp,
            url: '',
            cssClass: 'account-login',
            img: {
              title: 'no-profile-photo'
            },
            identifier: 'login',
            items: this.getCommonSubItems().concat([
              {
                id: 1,
                title: 'Webshop',
                url: '',
                redirectTo: Config.tnAccountDomain,
                img: {},
                items: []
              }
            ])
          },
        ]
      };

      return login;
    }

    login.item.item = {
      genericLinks: [
        {
          id: 1,
          title: labels.businessPortal,
          url: Config.businessPortalUrl,
          cssClass: '',
          img: {
            title: 'suitcase'
          },
          items: []
        }
      ]
    };

    return login;
  }

  private static getCommonSubItems() {
    return [
      {
        id: 2,
        title: 'Yettel app',
        url: Config.yettelAppUrl,
        redirectTo: Config.yettelAppUrl,
        img: {},
        items: [],
      },
      {
        id: 3,
        title: 'Hipernet TV',
        url: Config.hipernetUrl,
        redirectTo: Config.hipernetUrl,
        img: {},
        items: [],
      }];
  }

  private static getCartItem(numberOfOrderItems: number) {
    return {
      id: 5,
      title: `cart-${numberOfOrderItems}`,
      url: Config.cartOverviewNewUrl,
      redirectTo: Config.cartOverviewNewUrl,
      cssClass: '',
      img: {
        title: 'cart'
      },
      items: []
    };
  }

  private static getWishListItem() {
    return {
      id: 4,
      title: 'Wishlist',
      url: '',
      redirectTo: '',
      cssClass: '',
      img: {
        title: 'wishlist'
      },
      items: []
    };
  }

}
